module.exports = __webpack_public_path__ + "static/febri-aldi-1fe04071eeed78391c3b3c70fb306fbc.png";